import { useTrack } from '../tracks';
import { useLesson } from '../lessons';
import { getDisplayCategories } from 'academy-common-lib/utils/categories';
export const useTrackDisplayCategories = ({
  trackId
}) => {
  const {
    track,
    trackLoading,
    trackError
  } = useTrack(trackId);
  const trackDisplayCategories = track ? getDisplayCategories(track.subCategories) : null;
  return {
    trackDisplayCategories,
    trackDisplayCategoriesLoading: trackLoading,
    trackDisplayCategoriesError: trackError
  };
};
export const useLessonDisplayCategories = ({
  lessonId
}) => {
  const {
    lesson,
    lessonError,
    lessonLoading
  } = useLesson(lessonId);
  const lessonDisplayCategories = lesson ? getDisplayCategories(lesson.subCategories) : null;
  return {
    lessonDisplayCategories,
    lessonDisplayCategoriesLoading: lessonLoading,
    lessonDisplayCategoriesError: lessonError
  };
};